import { toFlatField } from '../oasis-types';
export const OstomyVersioned = {
    ostomy: { e1: { alias: 'ostomy', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
};
export const OstomySectionField = toFlatField(OstomyVersioned);
